import { render, staticRenderFns } from "./ProAppBody.vue?vue&type=template&id=2e99b105"
import script from "./ProAppBody.vue?vue&type=script&lang=js"
export * from "./ProAppBody.vue?vue&type=script&lang=js"
import style0 from "./ProAppBody.vue?vue&type=style&index=0&id=2e99b105&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports